import { Badge } from "@/components/ui/primitives";
import type { KbStatus } from "@/types/api";

const VARIANT: Record<KbStatus, "secondary" | "warning" | "success" | "destructive"> = {
  draft: "secondary",
  ingesting: "warning",
  ready: "success",
  failed: "destructive",
};

const LABEL: Record<KbStatus, string> = {
  draft: "draft",
  ingesting: "ingesting…",
  ready: "ready",
  failed: "failed",
};

export function KbStatusBadge({ status }: { status: KbStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
